import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HStack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { VehicleSelector } from 'store/selectors';
import AppRoutes from 'config/AppRoutes';
import PageLayout from 'ui/layout/PageLayout';
import { updateVehicle } from 'store/answers/answersSlice';
import Button from 'ui/molecules/Button';
import VideoBlock from 'components/VideoBlock';
import useStepNavigation from 'utils/hooks/useStepNavigation';
import useAsset, { AssetType } from 'utils/hooks/useAsset';

const PageElectricVehicle = () => {
  const currentRoute = AppRoutes.ELECTRIC_VEHICLE;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userValue = useSelector(VehicleSelector);
  const { navigateToNextStep, navigateToPreviousStep } =
    useStepNavigation(currentRoute);
  const [currentValue, setCurrentValue] = useState<boolean | undefined>(
    userValue
  );

  const videoUrl = useAsset(
    AssetType.VIDEO,
    `/06-charge/CHARGE${currentValue ? ' OUI ' : ' NON '}1000.mp4`
  );

  const handleChange = (newVal: boolean) => {
    setCurrentValue(newVal);
    dispatch(updateVehicle(newVal));
  };

  const handleContinue = () => {
    navigateToNextStep();
  };

  // --------------------- effects ------------------------

  // --------------------- render ------------------------

  return (
    <PageLayout
      title={t('ELECTRIC_VEHICLE_title')}
      buttonLabel={t('common.continue')}
      buttonCallback={handleContinue}
      backButton
      backCallback={navigateToPreviousStep}
      buttonSticky={false}
    >
      <Box height={{ base: '250px', md: '350px' }}>
        <VideoBlock
          loop={false}
          mt={{ base: '-20px', md: '-2px' }}
          videoUrl={videoUrl}
          height={{ base: '300px', md: '400px' }}
        />
      </Box>

      <HStack
        w={{ base: 'full', md: '60%' }}
        boxShadow="base"
        p="5px"
        borderRadius="25px"
        justifyContent="space-between"
      >
        <Button
          variant={currentValue ? 'radio-selected' : 'radio'}
          w="50%"
          onClick={() => handleChange(true)}
        >
          {t('common.yes')}
        </Button>
        <Button
          variant={!currentValue ? 'radio-selected' : 'radio'}
          w="50%"
          onClick={() => handleChange(false)}
        >
          {t('common.no')}
        </Button>
      </HStack>
    </PageLayout>
  );
};

export default PageElectricVehicle;
